
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import {
mapActions, mapState, mapMutations
}
from 'vuex'
import {
revive
}
from '@/api/ajax'
export default {
name: '',
props: {
showLog: {

default: false
},
questionIndex: {
default: 0
},
questionList: { // 题目LIST
type: Array,
default () {
return []
}
},
reviveNum: { //复活卡数
default: 0
},
integral: {
default: 0
}
},
directives: {
TransferDom
},
data() {
return {
canClick:true,
appFlag:false,
wrongFlag:true
}
},
methods: {
...mapMutations([
'SETREVICE'
]),
closeLog() {
this.$emit('update:showLog', false)
},
cannel() {

revive.returnIntegral().then(res => {
this.closeLog()
this.$router.push({
name: 'wrong',
query: {
rightNum: this.questionIndex,
wrongId: this.questionList[this.questionIndex].id,
first:true
}
})
})
},
openApp(){
sa.track('activity', {
action: 'vzb_dati2018',
type: 'open_app'
}, function() {
location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app'
});
},
setRevive(a,b,c) { // 复活后 回调
this.SETREVICE(false)
this.closeLog()
this.$emit('revive-card',true)
this.$vux.toast.show({
text: '复活成功，请继续答题',
type: 'text',
width: '7rem'
})
sa.track('activity', {
action: 'vzb_dati2018',
type: 'revive'
}, function() {});

},
confirm() {
if(this.reviveNum < 1){ //无复活卡
this.wrongFlag = false
this.appFlag = true
}else{

if(!this.canClick){
return false
}
this.canClick = false
revive.useReviveCard().then(res => {
if(res.data.status==1){
this.reviveNum -= 1
this.setRevive()
}
})









}

}
},
computed: {

},
components: {
XButton,
XDialog
},
created() {


}
}



// WEBPACK FOOTER //
// ./src/components/Resurrection.vue